import { connect } from 'react-redux';
import Login from '../../../components/views/Login';
import {
  submitMobileNumber,
  submitVerificationCode,
  restartLoginProcess,
  resendVerificationCode
} from '../../../modules/auth/actions';
import { mobileNumber } from '../../../modules/auth/selectors';
import { getFieldErrors } from '../../FormMessage/selectors';
import { isStorageAvailable } from '../../../modules/app/selectors';
import { incorrectNumber, goToAnonymousLogin } from '../../../modules/analytics/actions';

const mapDispatchToProps = {
  submitMobileNumber,
  submitVerificationCode,
  restartLoginProcess,
  resendVerificationCode,
  incorrectNumber,
  goToAnonymousLogin
};

const mapStateToProps = state => ({
  storageAvailable: isStorageAvailable(state),
  externalErrors: getFieldErrors(state),
  mobileNumber: mobileNumber(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
